import { type TileDescriptor } from "@features/metrics-explorer/types";

import { ChartLegendItem } from "./chart-legend-item";

interface Props {
  tiles: TileDescriptor[];
  onChange(id: string): void;
}

export const ChartLegend = ({ tiles, onChange }: Props) => {
  return (
    <div className="text-xs flex flex-wrap items-center justify-center gap-x-8 gap-y-4 px-[10%]">
      {tiles.map((tile, index) => (
        <ChartLegendItem
          key={tile.id}
          tile={tile}
          index={index}
          onChange={() => onChange(tile.id)}
        />
      ))}
    </div>
  );
};
